import React, { useEffect, useRef } from "react";
import ItodoImage from "../../../elements/itodo-img";

function SectionClients1({ hideTitle }) {
  const carouselRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    let scrollPosition = 0;
    const scrollSpeed = 1;

    const startScrolling = () => {
      timerRef.current = setInterval(() => {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        scrollPosition += scrollSpeed;

        if (scrollPosition >= maxScroll) {
          scrollPosition = 0;
        }

        carousel.scrollTo({
          left: scrollPosition,
          behavior: "smooth",
        });
      }, 30);
    };

    const stopScrolling = () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };

    // Start initial scrolling
    startScrolling();

    // Pause on hover
    const handleMouseEnter = () => stopScrolling();
    const handleMouseLeave = () => startScrolling();

    carousel.addEventListener("mouseenter", handleMouseEnter);
    carousel.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      stopScrolling();
      carousel.removeEventListener("mouseenter", handleMouseEnter);
      carousel.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  const clientLogos = [
    "onfonmedia.jpg",
    "onfon mobile.jpg",
    "digital sacco.jpg",
    "dma.jpg",
    "credo faster.jpg",
    "innovex.jpg",
    "luckybox.jpg",
    "mawingu.jpg",
    "m-float.jpg",
    "okoabia.jpg",
    "okoafloat.jpg",
    "ticketskali.jpg",
    // Duplicate for seamless loop
    // "onfonmedia.jpg",
    // "onfon mobile.jpg",
    // "digital sacco.jpg",
    // "dma.jpg",
  ];

  return (
    <div className="section-full p-t110 p-b80 sx-client-logo-1-outer sx-bg-white">
      <div className="container">
        {/* TITLE START */}
        {(hideTitle === undefined || hideTitle === null || !hideTitle) && (
          <div className="section-head center max-900">
            <div className="sx-head-s-title">Our Clients</div>
          </div>
        )}
        {/* TITLE END */}
        <div className="section-content">
          <div className="carousel-container" ref={carouselRef}>
            <div className="carousel-track">
              {/* Original logos */}
              {clientLogos
                .slice(0, clientLogos.length / 2)
                .map((logo, index) => (
                  <div key={`original-${index}`} className="client-logo-item">
                    <div className="client-logo-pic">
                      <ItodoImage
                        src={`images/client-logo/${logo}`}
                        alt={`Client Logo ${index + 1}`}
                        className="client-logo-image"
                      />
                    </div>
                  </div>
                ))}

              {/* Duplicated logos for seamless loop */}
              {clientLogos.slice(clientLogos.length / 2).map((logo, index) => (
                <div key={`duplicate-${index}`} className="client-logo-item">
                  <div className="client-logo-pic">
                    <ItodoImage
                      src={`images/client-logo/${logo}`}
                      alt={`Client Logo ${index + 1}`}
                      className="client-logo-image"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionClients1;
